import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=6f713e86&scoped=true&"
import script from "./loading.vue?vue&type=script&lang=js&"
export * from "./loading.vue?vue&type=script&lang=js&"
import style0 from "./loading.vue?vue&type=style&index=0&id=6f713e86&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f713e86",
  null
  
)

export default component.exports